import { AuthApp, GameApp, MemberApp, ProfileApp, ProvidersApp } from "apps";

import type { IApp } from "shared/types";

export default (): { apps: IApp[] } => {
	const authApp = new AuthApp();
	const memberApp = new MemberApp();
	const gameApp = new GameApp();
	const providersApp = new ProvidersApp();
	const profileApp = new ProfileApp();

	const apps: any[] = [authApp, memberApp, gameApp, providersApp, profileApp];

	return {
		apps
	};
};
